<template>
  <div class="no-border  card-2 card">
    <div class="card-body">
       <h4 class="m-b-30">List of Automations</h4>
       
       <div v-if="triggers.length && Array.isArray(triggers)">
         <b-table striped hover :items="triggers">
           <template #cell(dry_run)="data">
              <b-form-checkbox v-model="data.value" name="check-button" switch @change="switchUpdated(storeInState.id, 'dryRun', data.item.dry_run, data.item.actions)">
                 {{ data.field.label }}
              </b-form-checkbox>
           </template>
           <template #cell(active_status)="data">
              <b-form-checkbox v-model="data.value" name="check-button" switch  @change="switchUpdated(storeInState.id, 'activeStatus', data.item.active_status, data.item.actions)">
                 {{data.field.label}} 
              </b-form-checkbox>
           </template>
  
           <template #cell(actions)="data">
                 <b-dropdown  text="Actions" class="m-md-2 customDropdown" size="sm" variant="primary"  split split-variant="outline-primary">
                    <b-dropdown-item @click="editAuto(data.value)" ><span class="text-primary"><i class="fa fa-pencil-square-o" aria-hidden="true"></i> Edit</span></b-dropdown-item>
                    <b-dropdown-divider></b-dropdown-divider>
                    <b-dropdown-item @click="deleteAuto(data.value)"><span class="text-danger"><i class="fa fa-trash-o" aria-hidden="true"></i> Delete</span></b-dropdown-item>
                  </b-dropdown>
           </template>
  
         </b-table>
       </div>
       <div v-else>
         <b-alert variant="info" show>No automations added yet.</b-alert>
       </div>
    </div>
  </div>
</template>

<script>
 import UpsellAutomationService from '../../../services/upsell-automation.service';
  export default {
    mounted: function(){
       this.fetchTriggers()
    },
    watch: {
       storeInState(newValue, oldValue){
          this.fetchTriggers()
       }
    },
    methods: {
      async fetchTriggers(){
          try{
            const result = await UpsellAutomationService.fetchTriggersByStore(this.storeInState.id)
            this.triggers = result.data.triggers.map(trigger => {
               return {
                 title: trigger.title,
                 dry_run: trigger.dryRun == 'yes' ? true : false,
                 active_status: trigger.activeStatus == 'active' ? true : false,
                 actions: trigger.id
               }
            });
          }catch(e){
            console.log(e.response.data)
          }
      },
      editAuto(id){
         console.log(id);
         this.$router.push({name: 'upsell-add-update-automation', params: {id}})
      },
      async switchUpdated(shopifyStoreId, columnName, columnValue, id){
        columnValue = !columnValue;
        
        if(columnName == 'dryRun'){
          columnValue = columnValue ? 'yes' : 'no'
        }else if(columnName == 'activeStatus'){
          columnValue = columnValue ? 'active' : 'inactive'
        }

        try{
          const updateResult = await UpsellAutomationService.updateSingleColumn({shopifyStoreId, columnName, columnValue, id});

          if(updateResult){
            this.fetchTriggers()
          }

          this.$toasted.show(updateResult.data.message, {
              type: "success",
              action: {
                text: "Close",
                class: "toastBtnTxt",
                onClick: (e, toastObject) => {
                  toastObject.goAway(0);
                },
              },
              duration: 5000,
          });
        }catch(e){
          console.log(e)
        }
      },
      deleteAuto(id){
        this.$dialog
        .confirm('Please confirm to delete')
        .then(async (dialog) => { 
            const result = await UpsellAutomationService.deleteUpsellTrigger(id, this.storeInState.id)

            this.$toasted.show(result.data.message, {
              type: "success",
              action: {
                text: "Close",
                class: "toastBtnTxt",
                onClick: (e, toastObject) => {
                  toastObject.goAway(0);
                },
              },
              duration: 3000,
          });

          this.triggers = this.triggers.filter(trigger => trigger.actions != id)
          
         })
        .catch(() => {
          console.log('Clicked on cancel');
        });
      }
    },
    data() {
      return {
        triggers: []
      }
    },
    computed: {
        storeInState() {
          return this.$store.state.ecommerceStore.store
        },
    }
  }
</script>

<style lang="scss" scoped>
  .customDropdown{
    background-color: #fff;
  }
</style>